// @ts-nocheck
import * as types from '../types';
import { setPagination } from './pagination';
import { PAGINATION_KEYS } from '../../utils/constants';
import ReportsService from '../../services/ReportsService';
import PaymentService from '../../services/PaymentService';
import { handleErrorNotification } from '../../utils/render';
import { notification } from 'antd';
import paymentService from '../../services/PaymentService';
import { getPlayerDetails } from './player';

export const clearDepositsWithdrawalsReport = () => ({
    type: types.DEPOSITS_WITHDRAWALS_REPORTS_CLEARED,
});

export const setDepositsWithdrawals = payload => ({
    type: types.DEPOSITS_WITHDRAWALS_REPORTS_CHANGED,
    payload,
});

export const getPaymentHistory = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentReports = store.payment.depositsWithdrawals.reports || [];

    dispatch(setDepositsWithdrawals({ reports: params.offset > 0 ? currentReports : [] }));
    dispatch(
        setPagination(PAGINATION_KEYS.depositsWithdrawals, {
            isFetching: true,
        }),
    );

    const { info, items } = await ReportsService.getPaymentHistory({
        params,
    });

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.depositsWithdrawals, {
                isFetching: false,
            }),
        );
        return;
    }

    let newReports = [];

    if (params.offset > 0) {
        newReports = currentReports.concat(items);
    } else {
        newReports = items;
    }

    const hasMore = items.length >= params.limit;

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );

    dispatch(
        setPagination(PAGINATION_KEYS.depositsWithdrawals, {
            page: params.offset,
            size: params.limit,
            hasMore,
            isFetching: false,
        }),
    );

    return newReports;
};

export const declineWithdrawals = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { reports } = reduxStore.payment.depositsWithdrawals;

    const { info, items } = await PaymentService.declineWithdraw(params);

    if (!info.success) return { info };

    const newReports = reports.map(report => {
        const updatedReport = items.find(item => item.transactionId === report.transactionId);

        if (updatedReport) {
            return {
                ...report,
                ...updatedReport,
            };
        } else return report;
    });

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );

    return { info };
};

export const confirmWithdrawals = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { reports } = reduxStore.payment.depositsWithdrawals;

    const { info, items } = await PaymentService.confirmWithdraw(params);

    if (!info.success) return { info };

    const newReports = reports.map(report => {
        const updatedReport = items.find(item => item.transactionId === report.transactionId);

        if (updatedReport) {
            return {
                ...report,
                ...updatedReport,
                transactionId: updatedReport.octTransactionId,
            };
        } else return report;
    });

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );

    return { info };
};

export const manualConfirmWithdrawals = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { reports } = reduxStore.payment.depositsWithdrawals;

    const { info, items } = await PaymentService.manualConfirmWithdraw(params);

    if (!info.success) return { info };

    const newReports = reports.map(report => {
        const updatedReport = items.find(item => item.transactionId === report.transactionId);

        if (updatedReport) {
            return {
                ...report,
                ...updatedReport,
                transactionId: updatedReport.octTransactionId,
            };
        } else return report;
    });

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );

    return { info };
};

export const cancelWithdrawals = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { reports } = reduxStore.payment.depositsWithdrawals;

    const { info, items } = await PaymentService.cancelTransaction(params);

    if (!info.success) return { info };

    const newReports = reports.map(report => {
        const updatedReport = items.find(item => item.transactionId === report.transactionId);

        if (updatedReport) {
            return {
                ...report,
                ...updatedReport,
            };
        } else return report;
    });

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );

    return { info };
};

export const manualCancelWithdrawals = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { reports } = reduxStore.payment.depositsWithdrawals;

    const { info, items } = await PaymentService.manualCancelTransaction(params);

    if (!info.success) return { info };

    const newReports = reports.map(report => {
        const updatedReport = items.find(item => item.transactionId === report.transactionId);

        if (updatedReport) {
            return {
                ...report,
                ...updatedReport,
            };
        } else return report;
    });

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );

    return { info };
};

export const holdTransaction = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { reports } = reduxStore.payment.depositsWithdrawals;

    const { info, item } = await PaymentService.holdTransaction(params);

    if (!info.success) {
        handleErrorNotification(info.errors);
        return;
    }

    const newReports = reports.map(report => {
        if (report.transactionId === params.transactionId) {
            return {
                ...report,
                ...item,
            };
        }
        return report;
    });

    dispatch(
        setDepositsWithdrawals({
            reports: newReports,
        }),
    );
};

export const getWithdrawalAutoprocessingRules = () => async dispatch => {
    dispatch(setPagination(PAGINATION_KEYS.withdrawalAutoprocessingRules, { isFetching: true }));

    const data = await PaymentService.getWithdrawalAutoprocessingRuleList();

    if (data.items) {
        dispatch(setWithdrawalAutoprocessingRules(data.items));
    }

    dispatch(setPagination(PAGINATION_KEYS.withdrawalAutoprocessingRules, { isFetching: false }));
};

export const setWithdrawalAutoprocessingRules = current => ({
    type: types.WITHDRAWAL_AUTOPROCESSING_LIST_CHANGED,
    payload: current,
});

export const createWithdrawalAutoprocessingRule = data => async dispatch => {
    const response = await PaymentService.createWithdrawalAutoprocessingRule(data);

    if (response.info?.success) {
        notification.success({
            message: 'Ruleset Created!',
        });
    } else {
        notification.error({
            message: 'Create Failed!',
        });
    }

    return response.info;
};

export const updateWithdrawalAutoprocessingRule = (id, data) => async dispatch => {
    const response = await PaymentService.updateWithdrawalAutoprocessingRule(id, data);

    if (response.info?.success) {
        notification.success({
            message: 'Ruleset Updated!',
        });
    } else {
        notification.error({
            message: 'Update Failed!',
        });
    }

    return response.info;
};

export const deleteWithdrawalAutoprocessingRule = id => async (dispatch, getState) => {
    const response = await PaymentService.deleteWithdrawalAutoprocessingRule(id);

    if (response.info.success) {
        notification.success({
            message: 'Item Deleted!',
        });
        dispatch(getWithdrawalAutoprocessingRules());
    } else {
        notification.error({
            message: 'Delete Failed!',
        });
    }
};

export const changeWithdrawalAutoprocessingDrawer = (isVisible, type) => ({
    type: types.WITHDRAWAL_AUTOPROCESSING_DRAWER_CHANGED,
    payload: {
        isVisible,
        type,
    },
});

export const changeCurrentWithdrawalAutoprocessing = current => ({
    type: types.WITHDRAWAL_AUTOPROCESSING_CURRENT_CHANGED,
    payload: current,
});

export const clearCurrentWithdrawalAutoprocessing = () => ({
    type: types.WITHDRAWAL_AUTOPROCESSING_CURRENT_CHANGED,
    payload: null,
});

export const blockUserPayment = params => async dispatch => {
    const { info } = await paymentService.blockUserPayment(params);

    if (!info.success) return info;

    dispatch(getPlayerDetails(params.accountNumber));

    return { info };
};

export const getPaymentMethodsList = () => async dispatch => {
    const data = await PaymentService.getPaymentMethodsList();

    if (data.items) {
        dispatch(setPaymentMethodsList(data.items));
    }
};

export const setPaymentMethodsList = current => ({
    type: types.PAYMENT_METHODS_LIST_CHANGED,
    payload: current,
});

export const setPaymentMethodDrawerProps = payload => ({
    type: types.PAYMENT_METHODS_DRAWER_PROPS_CHANGED,
    payload,
});

export const createPaymentMethod = data => async dispatch => {
    const response = await PaymentService.createPaymentMethod(data);

    if (response.info?.success) {
        notification.success({
            message: 'Payment Method Created!',
        });

        dispatch(getPaymentMethodsList());
    } else {
        notification.error({
            message: 'Create Failed!',
        });
    }

    return response.info;
};

export const updatePaymentMethodStatus = data => async dispatch => {
    const response = await PaymentService.updatePaymentMethodStatus(data);

    if (response.info?.success) {
        notification.success({
            message: 'Payment Method Status Updated!',
        });

        dispatch(getPaymentMethodsList());
    } else {
        notification.error({
            message: 'Update Failed!',
        });
    }

    return response.info;
};

export const updatePaymentMethodGlobalStatus = data => async dispatch => {
    const response = await PaymentService.updatePaymentMethodGlobalStatus(data);

    if (response.info?.success) {
        notification.success({
            message: 'Payment Method Status Updated!',
        });

        dispatch(getPaymentMethodsList());
    } else {
        notification.error({
            message: 'Update Failed!',
        });
    }

    return response.info;
};

export const updatePlatformStatus =
    ({ id, platforms, comment }) =>
    async dispatch => {
        const response = await PaymentService.updatePlatformStatus({ id, platforms, comment });

        if (response.info?.success) {
            notification.success({
                message: 'Platform Status Updated!',
            });

            dispatch(getPaymentMethodsList());
        } else {
            notification.error({
                message: 'Update Failed!',
            });
        }

        return response.info;
    };
